import type { IncidentLog } from "@/models"
import { changeBuilder } from "@/modifications"
import type { Instant } from "@/Temporal"
import type { IncidentLogHandler } from "../shared/incident-form/IncidentLogHandler"

export class PdfViewIncidentHandler implements IncidentLogHandler {
	readonly incident: IncidentLog
	readonly readOnly = true
	readonly isNewIncident = false
	readonly changeBuilder = changeBuilder<IncidentLog>()

	constructor(incident: IncidentLog) {
		this.incident = incident
	}

	createIncident(): Promise<void> {
		return Promise.reject(this.createChangeError())
	}

	validateForm(): Promise<boolean> {
		return Promise.resolve(false)
	}

	submitChange(): void {
		throw this.createChangeError()
	}

	submitDebouncedChange(): void {
		this.submitChange()
	}

	awaitChange(): Promise<boolean> {
		return Promise.reject(this.createChangeError())
	}

	uploadDocuments(): Promise<void> {
		return Promise.reject(this.createChangeError())
	}

	formatTime(time: Instant): string {
		return time.toUTCDateTimeString()
	}

	private createChangeError() {
		return new Error("No changes can be made, as the incident is in view only mode")
	}
}
